import { useState, useLayoutEffect, RefObject } from 'react';

interface UseIsOverflowProps {
  ref: RefObject<HTMLDivElement>;
  callback?: (hasOverflow: boolean) => void;
  overflowDirection?: 'x' | 'y';
}

/**
 * Check if an element is overflowing either width or height
 * defaults to height (y)
 * Copied from https://www.robinwieruch.de/react-custom-hook-check-if-overflow/
 */
export const useIsOverflow = ({ ref, callback, overflowDirection = 'y' }: UseIsOverflowProps): boolean => {
  const [isOverflow, setIsOverflow] = useState(false);

  useLayoutEffect(() => {
    const { current } = ref;

    if (current) {
      const trigger = (): void => {
        const hasOverflow =
          overflowDirection === 'y'
            ? current.scrollHeight > current.clientHeight
            : current.scrollWidth > current.clientWidth;

        setIsOverflow(hasOverflow);

        if (callback) {
          callback(hasOverflow);
        }
      };

      if (current) {
        trigger();
      }
    }
  }, [callback, overflowDirection, ref]);

  return isOverflow;
};
